import { type ColumnTypes } from '@scoir/my-colleges'

import api from 'common/api'

type UserDisplay = ColumnTypes.UserDisplay

export const setUserPref = (PREF_NAME: string, value: boolean | UserDisplay) =>
  api.post<boolean | UserDisplay, UserDisplay>(`/api/user_ui_preference/${PREF_NAME}`, value)

export const setGenericBoolUserPref = (PREF_NAME: string, value: boolean | UserDisplay) =>
  api.post<boolean | UserDisplay, UserDisplay>(`/api/user_ui_preference/generic/bool/${PREF_NAME}`, value)

export type { UserDisplay }
